import * as yup from 'yup'
import { sumBy } from 'lodash-es'
import { currencyUtils } from '../../../../../utils'

/**
 * Validation for the active-invoice payment allocation. Extracted from the component so
 * it can be tested without pulling in the `views/components` barrel.
 *
 * The form validates on mount, so these rules are what keep the Approve Payments button
 * disabled on an over-allocated invoice before the user has touched anything.
 */
export const validationSchema = yup.object().shape({
  beneficiaries: yup
    .array(
      yup.object().shape({
        beneficiary: yup.object().shape({
          type: yup.string(),
          value: yup.object().shape({
            amountToPay: yup.mixed().test('amountToPay', function (val) {
              const value = val || 0
              if (value > this.parent.balance) {
                return this.createError({
                  path: this.path,
                  message: `Amount can't exceed Payment rule balance of ${currencyUtils.formatCurrency(
                    this.parent.balance,
                  )}`,
                })
              }
              return true
            }),
            balance: yup.number(),
            /** @todo remove globally */
            // beneficiaryCategory: yup.string(),
            id: yup.string(),
            partyId: yup.string(),
            partyTag: yup.string(),
            reference: yup.string(),
            vat: yup.boolean(),
          }),
        }),
      }),
    )
    .test('beneficiaries', function (beneficiaries) {
      const beneficiariesTotalAmount = sumBy(
        beneficiaries,
        (b: any) => parseFloat(b.beneficiary.value.amountToPay) || 0,
      )
      if (this.parent.customerAvailableFunds && beneficiariesTotalAmount > this.parent.customerAvailableFunds) {
        return this.createError({
          path: 'general',
          message: `Total payment amounts can't exceed available funds of ${
            currencyUtils.formatCurrency(this.parent.customerAvailableFunds) as string
          }`,
        })
      }
      if (beneficiariesTotalAmount > this.parent.balance) {
        return this.createError({
          path: 'general',
          message: `Total payment amounts can't exceed invoice balance of ${
            currencyUtils.formatCurrency(this.parent.balance) as string
          }`,
        })
      }
      return true
    }),
})
